import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import "./Catbears_Register.scss";

const NewPassword = ({ authProps, changePasswordHandler }) => {
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [message, setMessage] = useState(null);
  const { t } = useTranslation();
  const history = useHistory();

  const onResetPassword = (event) => {
    event.preventDefault();
    if (password !== repeatPassword) {
      setMessage(t("authentication.passwordsDoNotMatch"));
      return;
    }
    changePasswordHandler(password);
  };

  return (
    <div className="login-page-container">
      <div className="Onboarding-title">{t('loginFlow.resetPasswordTitle') || 'Reset Password'}</div>
      <div className="Catbears_Register">
        <form onSubmit={onResetPassword}>
          <div className={"modal__form--error-msg " + (authProps.isError ? "" : " displayNone ")}>{authProps.errorMsg}</div>
          <div className={"modal__form--error-msg " + (message ? "" : " displayNone ")}>{message}</div>
          <div>
            <label className={"register-label noselect "}>{t('loginFlow.password') || 'Password'}</label>
            <input type="Password" className="input input-authMenu" value={password} onChange={e => setPassword(e.target.value)}></input>
          </div>
          <div>
            <label className={"register-label noselect "}>{t('loginFlow.repeatPassword') || 'Repeat Password'}</label>
            <input type="Password" className="input input-authMenu" value={repeatPassword} onChange={e => setRepeatPassword(e.target.value)}></input>
          </div>

          <button className={"noselect buttonCatbears buttonCatbears_CTA register-btn arcadeBtn " + (authProps.isLoading ? "preloaderGif " : " ")} type="submit">{authProps.isLoading ? "" : (t('loginFlow.changePassword') || 'Change Password')}</button>
        </form>
        <div className="below-register-form noselect ">
          <p className="register_already-has-account">
            {t('loginFlow.rememberPassword') || 'Remember your password?'}{" "}
            <a className="catbearsLink" onClick={() => history.push('/login')}>{t('loginFlow.logInBtn') || 'Log In'}</a>
          </p>
        </div>
      </div>
    </div>
  );
};
export default NewPassword;